import { createContext, useCallback, useContext } from 'react';

import useInsightsGroupTypeManagement from 'components/insights/hooks/useInsightsGroupTypeManagement';
import GroupType from 'models/GroupType';
import Profile from 'models/Profile';
import { useBusinessDevelopmentActions, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

import BusinessDevelopmentPage from './BusinessDevelopmentPage';

type BusinessDevelopmentContextType = {
  profile: Profile;
  predecessorGroupType: GroupType | undefined;
  groupTypes: GroupType[];
  onTabChange: (groupType: GroupType) => void;
};

export const BusinessDevelopmentContext = createContext<BusinessDevelopmentContextType>({
  profile: {} as Profile,
  predecessorGroupType: undefined,
  groupTypes: [],
  onTabChange: () => {},
});

export const useBusinessDevelopmentContext = () => useContext(BusinessDevelopmentContext);

const buildGroupTypes = (managed: GroupType[], providedIds: Set<string>) =>
  managed.filter((gt) => !providedIds.has(gt.id));

const BusinessDevelopmentContainer = () => {
  const selectedGroupType = useBusinessDevelopmentStore((state) => state.selectedGroupType);
  const { setSelectedGroupType, setPredecessorGroupTypeId, resetFilters } = useBusinessDevelopmentActions();

  const { profile, predecessorGroupType, groupTypes, handleTabChange } = useInsightsGroupTypeManagement({
    preferenceKey: 'businessDevelopmentProviderType',
    buildGroupTypes: useCallback(buildGroupTypes, []),
    setSelectedGroupType,
    setPredecessorGroupTypeId,
    resetFilters,
    selectedGroupType,
  });

  return (
    <BusinessDevelopmentContext value={{ profile, predecessorGroupType, groupTypes, onTabChange: handleTabChange }}>
      {predecessorGroupType && selectedGroupType && <BusinessDevelopmentPage />}
    </BusinessDevelopmentContext>
  );
};

export default BusinessDevelopmentContainer;
